import {Modulo} from './Modulo';

export class ModuloConfig extends Modulo {
  isAvailable: boolean;
  activationDate?: Date;
  expiryDate?: Date;
  sottoModuli?: ModuloConfig[];
}
